import { createMutation } from "react-query-kit";
import type { MutationFunction } from "@tanstack/react-query";

import { axiosClient, queryClient } from "../../clients";

import type { IMemberBooks } from "./routeType";

import type { IPickMutation } from "@/api";
import { getApi } from "@api/apiPath";
import { useGetAllMemberBooks } from "@/api/members/books/getAll";
import { useGetMemberBook } from "@/api/members/books/get";

const { getPath } = getApi("members.books.post");

type IExtractedRouteType = IMemberBooks["bookSingleCreate"];

export type IPostMemberBook = IPickMutation<IExtractedRouteType>;

const postMemberBook: MutationFunction<
  IPostMemberBook["response"],
  IPostMemberBook["variables"]
> = ({ memberId, ...data }) => {
  return axiosClient.post(getPath({ memberId }), data);
};

export const usePostMemberBook = createMutation({
  mutationFn: postMemberBook,
  onSuccess: (_, { memberId }) => {
    queryClient.invalidateQueries({
      queryKey: useGetAllMemberBooks.getKey(),
    });
    queryClient.invalidateQueries({
      queryKey: useGetMemberBook.getKey({ memberId }),
    });
  },
});
